import { PageTitle, PageLabeledButton } from 'components';
import React, { useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { types } from 'store/user/types';
import { types as formTypes } from 'store/form/types';
import { readUrlParams, resolveMessageCode } from 'utils';
import { redirectToHome } from 'store/user/actions';

const AuthErrorPage = () => {
  const dispatch = useDispatch();
  const message =  useSelector(state => state.form.message);
  useLayoutEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    const urlParams = readUrlParams();
    if (urlParams.reason) {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: resolveMessageCode(urlParams.reason) });
    }
    dispatch({ type: formTypes.SET_FORM_INITIATED });
  }, []);
  return (
    <div className="autherror-page">
      <PageTitle message={message} pageName="autherror" />
      <PageLabeledButton 
        labelMessage="Συνδεθείτε για να συνεχίσετε"
        pageName="homeret"
        buttonTitle="Είσοδος"
        buttonAction={redirectToHome}
      />
    </div>
  );
};

export default AuthErrorPage;
